import _findIndex from 'lodash/findIndex';
import { setup } from '../config';
const { maxNumberOfEvents } = setup;

const _ = {
  findIndex: _findIndex,
}

const getMaxPage = ({ numberOfBlocks }) => {
  return Math.ceil(numberOfBlocks/maxNumberOfEvents);
}

const getTargetPage = ({ targetId, blockList }) => {
  const targetBlockIndex = _.findIndex(blockList, (o) => o.timestamp === targetId) + 1;
  if (targetBlockIndex === 0) {
    return null;
  }
  return Math.ceil(targetBlockIndex/maxNumberOfEvents);
};

const whenIsIt = ({
  timestamp,
}) => {
  const currentTimestamp = new Date().getTime();
  const milliSecOfMinute = 60 * 1000;
  const milliSecOfHour = 60 * milliSecOfMinute;
  const milliSecOfDay = 24 * milliSecOfHour;
  const milliSecOfMonth = 30 * milliSecOfDay;
  const milliSecOfYear = 12 * milliSecOfMonth;
  const difference = currentTimestamp - (+timestamp);
  if (difference >= milliSecOfYear) {
    return `${Math.floor(difference/milliSecOfYear)}年`;
  }
  if (difference >= milliSecOfMonth) {
    return `${Math.floor(difference/milliSecOfMonth)}個月`;
  }
  if (difference >= milliSecOfDay) {
    const days = Math.floor(difference/milliSecOfDay);
    const hours = Math.floor((difference - days * milliSecOfDay)/milliSecOfHour);
    return `${days}天${hours}小時`;
  }
  if (difference >= milliSecOfHour) {
    const hours = Math.floor(difference/milliSecOfHour);
    const minutes = Math.floor((difference - hours * milliSecOfHour)/milliSecOfMinute);
    return `${hours}小時${minutes}分`;
  }
  if (difference >= milliSecOfMinute) {
    const minutes = Math.floor(difference/milliSecOfMinute);
    const secs = Math.floor((difference - minutes * milliSecOfMinute)/1000);
    return `${minutes}分${secs}秒`;
  }
  if (difference < milliSecOfMinute && difference >= 0) {
    return `${Math.floor(difference/milliSecOfMinute)}秒`;
  }
  return '';
}

function formatNumber(num) {
  try {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  } catch (e) {
    return 0;
  }
}

function timestampToString(timestamp) {
  const dateObject = new Date(timestamp);
  return `${dateObject.getFullYear()}/${dateObject.getMonth()+1}/${dateObject.getDate()} ${dateObject.getHours()}:${dateObject.getMinutes()}`
}

function cecDateStringToHumanRead(dateString) {
  if (!dateString) {
    return '';
  }
  const year = 2020;
  const month = dateString.substring(0, 2);
  const day =  dateString.substring(2, 4);
  const hour = dateString.substring(4, 6);
  const minute = dateString.substring(6, 8);
  const second = dateString.substring(8, 10);
  return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
}

const autoScroll = ({
  targetId,
  offset = 0,
}) => {
  const elem = document.getElementById(targetId);
  if (window && elem) {
    // To trigger onLeave of waypoint, we need plus 1
    let target = window.pageYOffset + elem.getBoundingClientRect().top - offset;
    // let target = elem.offsetTop;
    // node.offsetTop
    window.scrollTo({
      top: target + 1,
      behavior: 'smooth'
    });
  }
}

const voteNumberToString = (number) => {
  const base = 10000;
  const numberOfTenThounsand = parseInt((number / base), 10);
  // const remainder = formatNumber(number % base);
  const remainder = number % base;
  if (numberOfTenThounsand === 0) {
    return `${remainder}票`;
  }
  return `${numberOfTenThounsand}萬${remainder}票`;
}

export {
  getTargetPage,
  whenIsIt,
  getMaxPage,
  formatNumber,
  timestampToString,
  autoScroll,
  cecDateStringToHumanRead,
  voteNumberToString,
}
